"use client";

import { useTranslations } from "next-intl";
import S from "./index.module.scss";
import { useDetailSuccessData } from "../../hooks/useDetailSuccessData";
import Image from "next/image";

const SuccessContent = () => {
  const t = useTranslations("success");
  const { content, name, qualification, avatar } = useDetailSuccessData();

  const text = t.rich(content, {
    default: chunks => <p className={S.default}>{chunks}</p>,
    text: chunks => <p className={S.text}>{chunks}</p>,
    title: chunks => <p className={S.title}>{chunks}</p>,
    quote: chunks => <p className={S.quote}>{chunks}</p>,
    wrapper: chunks => <div className={S.wrapper}>{chunks}</div>,
    quoteImage: chunks => (
      <div className={S.quoteImage}>
        <Image src={avatar} alt="" width={80} height={80} />
        <div className={S.quoteText}>
          <span>{chunks}</span>
          <div className={S.info}>
            <p className={S.infoName}>{name}</p> <p className={S.infoQualification}>{qualification}</p>
          </div>
        </div>
      </div>
    ),
    image: chunks => <Image src={chunks?.toString() as string} alt="" width={1400} height={640} />,
  });

  return <div className={S.container}>{text}</div>;
};

export default SuccessContent;
